module.exports = __webpack_public_path__ + "static/img/2018-01-30.d5af729.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/press/2018-01-30.png
// module id = XjkK
// module chunks = 1